import React, { useState, useEffect } from "react";
import axios from "axios";
import * as Yup from "yup";
import { Formik } from "formik";
import { Col, Row, Input, Button, InputGroup, Label } from "reactstrap";
import { useHistory } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker-cssmodules.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import { UserConsumer } from "../../UserContext";
import { AlertPopups } from "../../components/AlertPopups";
import Header from "../../components/Header";
import { MyProfile_API } from "./MyProfile_API";
import { Routes } from "../../configurations/config";

function EditProfile() {
	let token = null;
	const history = useHistory();
	const [employeeInfo, setEmployeeInfo] = useState(null);

	const validate = Yup.object().shape({
		emergencyContactName: Yup.string().required(),
		emergencyContactPhoneNumber1: Yup.string().required(),
		emergencyContactPhoneNumber2: Yup.string().required(),
		emergencyContactAddress: Yup.string()
			.required("Address is Required")
			.max(500, "Max 500 characters allowed")
			.nullable(),
	});

	useEffect(() => {
		const header = { Authorization: `Bearer ${token}` };
		axios
			.get(`${MyProfile_API.GetMyProfile}`, {
				headers: header,
			})
			.then(({ status, data }) => {
				if (status === 200) {
					setEmployeeInfo(data);
				}
			});
	}, []);

	const handleChange = (temp, displayCode, e) => {
		if (displayCode === 2) {
			//datePicker
			setEmployeeInfo({
				...employeeInfo,
				["passportExpiryDate"]: temp,
			});
		} else {
			const { name, value } = temp.target;
			setEmployeeInfo({
				...employeeInfo,
				[name]: value,
			});
		}
	};
	const handleSubmit = () => {
		axios
			.put(`${MyProfile_API.PutMyProfile}`, employeeInfo, {
				headers: { Authorization: `Bearer ${token}` },
			})
			.then(({ status }) => {
				if (status === 200) {
					AlertPopups.successAlert.fire({
						text: "Employee Info Updated",
					});
					history.push(Routes.MyProfile);
				} else {
					AlertPopups.ErrorAlert.fire({
						text: "Employee Info Updation Error",
					});
				}
			})
			.catch((error) => {
				if (error.response)
					AlertPopups.ErrorAlert.fire({
						text: "Employee Info Updation Error",
					});
			});
	};
	return (
		<UserConsumer>
			{(userDetails) => {
				token = userDetails.token;
				return (
					<>
						<div className="container-fluid pl-3 pr-3">
							<Header
								title="Edit Profile"
								headerBorder="false"
								navigateBack={() => history.goBack()}
							/>

							{employeeInfo && (
								<Formik
									enableReinitialize={true}
									initialValues={employeeInfo}
									validationSchema={validate}
									validateOnChange={true}
									onSubmit={() => {
										handleSubmit();
									}}
								>
									{({ errors, handleSubmit }) => (
										<form onSubmit={handleSubmit}>
											<>
												<div className="formInfoContainer my-3">
													<div className="formInfoContainerHeader ">
														<Label sm={12}>
															Employee Information
														</Label>
													</div>

													<Col>
														<Row className="py-2 px-2">
															<Col md={3} lg={2}>
																<div className="formDetailHeader">
																	<div>
																		Employee
																		Name
																	</div>
																</div>
															</Col>
															<Col md={3} lg={4}>
																<p className="formValueContainer">
																	{
																		employeeInfo.employeeName
																	}
																</p>
															</Col>
															<Col md={3} lg={2}>
																<div className="formDetailHeader">
																	<div>
																		Employee
																		Code
																	</div>
																</div>
															</Col>
															<Col md={3} lg={4}>
																<p className="formValueContainer">
																	{
																		employeeInfo.employeeCode
																	}
																</p>
															</Col>
															<Col md={3} lg={2}>
																<div className="formDetailHeader">
																	<div>
																		Employee
																		Login
																	</div>
																</div>
															</Col>
															<Col md={3} lg={4}>
																<p className="formValueContainer">
																	{
																		employeeInfo.employeeLogin
																	}
																</p>
															</Col>
															<Col md={3} lg={2}>
																<div className="formDetailHeader">
																	<div>
																		Supervisor
																		Name
																	</div>
																</div>
															</Col>
															<Col md={3} lg={4}>
																<p className="formValueContainer">
																	{
																		employeeInfo.supervisorName
																	}
																</p>
															</Col>
															<Col md={3} lg={2}>
																<div className="formDetailHeader">
																	<div>
																		Department
																		Name
																	</div>
																</div>
															</Col>
															<Col md={3} lg={4}>
																<p className="formValueContainer">
																	{
																		employeeInfo.departmentName
																	}
																</p>
															</Col>
															<Col md={3} lg={2}>
																<div className="formDetailHeader">
																	<div>
																		Contact
																		No.
																	</div>
																</div>
															</Col>
															<Col
																md={3}
																lg={4}
																className="mt-2"
															>
																<Input
																	type="text"
																	name="emergencyContactPhoneNumber2"
																	value={employeeInfo.emergencyContactPhoneNumber2?.replace(
																		/[^0-9+]/gi,
																		""
																	)}
																	onChange={(
																		value,
																		event
																	) =>
																		handleChange(
																			value,
																			3,
																			event
																		)
																	}
																	className={`supDesciptionBox ${
																		errors.emergencyContactPhoneNumber2
																			? "h-auto invalid"
																			: "h-auto"
																	}`}
																/>
															</Col>
															<Col md={3} lg={2}>
																<div className="formDetailHeader">
																	<div>
																		Emergency
																		Contact
																	</div>
																</div>
															</Col>
															<Col md={3} lg={4}>
																<Input
																	type="text"
																	name="emergencyContactName"
																	value={
																		employeeInfo.emergencyContactName
																	}
																	onChange={(
																		value,
																		event
																	) =>
																		handleChange(
																			value,
																			3,
																			event
																		)
																	}
																	className={`supDesciptionBox ${
																		errors.emergencyContactName
																			? "h-auto invalid"
																			: "h-auto"
																	}`}
																/>
															</Col>
															<Col md={3} lg={2}>
																<div className="formDetailHeader">
																	<div>
																		Emergency
																		Contact
																		No.
																	</div>
																</div>
															</Col>
															<Col
																md={3}
																lg={4}
																className="my-1"
															>
																<Input
																	type="text"
																	name="emergencyContactPhoneNumber1"
																	value={employeeInfo.emergencyContactPhoneNumber1?.replace(
																		/[^0-9+]/gi,
																		""
																	)}
																	onChange={(
																		value,
																		event
																	) =>
																		handleChange(
																			value,
																			3,
																			event
																		)
																	}
																	className={`supDesciptionBox ${
																		errors.emergencyContactPhoneNumber1
																			? "h-auto invalid"
																			: "h-auto"
																	}`}
																/>
															</Col>

															<Col md={3} lg={2}>
																<div className="formDetailHeader">
																	<div>
																		Passport
																		No.
																	</div>
																</div>
															</Col>
															<Col
																md={3}
																lg={4}
																className="mt-2"
															>
																<Input
																	type="text"
																	name="passportNumber"
																	value={
																		employeeInfo.passportNumber
																	}
																	onChange={(
																		value,
																		event
																	) =>
																		handleChange(
																			value,
																			3,
																			event
																		)
																	}
																	className={`supDesciptionBox ${
																		errors.passportNumber
																			? "h-auto invalid"
																			: "h-auto"
																	}`}
																/>
															</Col>
															<Col md={3} lg={2}>
																<div className="formDetailHeader">
																	<div>
																		Passport
																		Expiry
																		Date
																	</div>
																</div>
															</Col>
															<Col
																md={3}
																lg={4}
																className="datepicker-wrapper"
															>
																<InputGroup className="datepicker-wrapper">
																	<DatePicker
																		showYearDropdown
																		showMonthDropdown
																		dateFormatCalendar=" " //for title
																		dateFormat="dd/MM/yyyy"
																		name="passportExpiryDate"
																		className={`editProfile-container ${
																			errors.passportExpiryDate
																				? "h-auto invalid"
																				: "h-auto"
																		}`}
																		selected={
																			employeeInfo.passportExpiryDate
																				? new Date(
																						employeeInfo.passportExpiryDate
																				  )
																				: null
																		}
																		onChange={(
																			value,
																			event
																		) =>
																			handleChange(
																				value,
																				2,
																				event
																			)
																		}
																		onChangeRaw={(
																			e
																		) => {
																			e.preventDefault();
																		}}
																		autoComplete="off"
																	/>

																	<FontAwesomeIcon
																		icon={
																			faCalendarAlt
																		}
																		className="calender-icon"
																		color="keppel"
																	/>
																</InputGroup>
															</Col>
															<Col md={3} lg={2}>
																<div className="formDetailHeader">
																	<div>
																		Blood
																		Group
																	</div>
																</div>
															</Col>
															<Col
																md={3}
																lg={4}
																className="my-1"
															>
																<Input
																	type="text"
																	name="bloodGroup"
																	value={
																		employeeInfo.bloodGroup
																	}
																	onChange={(
																		event
																	) => {
																		setEmployeeInfo(
																			{
																				...employeeInfo,
																				[event
																					.target
																					.name]:
																					event.target.value.replace(
																						/d/g,
																						""
																					),
																			}
																		);
																	}}
																	className={`supDesciptionBox ${
																		errors.bloodGroup
																			? "h-auto invalid"
																			: "h-auto"
																	}`}
																/>
															</Col>
															<Col md={3} lg={2}>
																<div className="formDetailHeader">
																	<div>
																		Address
																	</div>
																</div>
															</Col>
															<Col md={3} lg={4}>
																<Input
																	type="textarea"
																	name="emergencyContactAddress"
																	onChange={(
																		value,
																		event
																	) =>
																		handleChange(
																			value,
																			4,
																			event
																		)
																	}
																	value={
																		employeeInfo.emergencyContactAddress
																	}
																	className={`supDesciptionBox ${
																		errors.emergencyContactAddress
																			? "h-auto invalid"
																			: "h-auto"
																	}`}
																/>
															</Col>
															<Col md={3} lg={2}>
																<div className="formDetailHeader">
																	<div>
																		Linkedin
																		URL
																	</div>
																</div>
															</Col>
															<Col
																md={3}
																lg={4}
																className="my-1"
															>
																<Input
																	type="text"
																	name="linkedInProfileURL"
																	value={
																		employeeInfo.linkedInProfileURL
																	}
																	onChange={(
																		event
																	) => {
																		setEmployeeInfo(
																			{
																				...employeeInfo,
																				[event
																					.target
																					.name]:
																					event
																						.target
																						.value,
																			}
																		);
																	}}
																	className={`supDesciptionBox`}
																/>
															</Col>
														</Row>
													</Col>
												</div>
												<div className="btns">
													<Button
														type="submit"
														className="submit-btn leftBtn"
													>
														Update
													</Button>
												</div>
											</>
										</form>
									)}
								</Formik>
							)}
						</div>
					</>
				);
			}}
		</UserConsumer>
	);
}

export default EditProfile;
